import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
 
const DataTile = (props) => {
 const [content, setContent]=useState("")
 const [isNarrow, setIsNarrow]=useState(true)
 const days = {
    Poniedziałek: "Pon",
    Wtorek: "Wt",
    Środa: "Śr",
    Czwartek: "Czw",
    Piątek: "Pt",
    Sobota: "Sob",
    Niedziela:"Ndz"
 }
 useEffect(()=>{
    if(props.children != undefined){
        let contentValueDay = props.children.split(" ")[0]
        let contentValueHouer = props.children.split(" ")[1]
        setContent(days[contentValueDay])
    }
 },[])
function hoverWidth(){
    
    setTimeout(() => {
        setIsNarrow(false) 
    }, 100);
}
function hoverNarrow(){
    setTimeout(() => {
        setIsNarrow(true)  
    }, 100);
    
} 

    return <> 
    {isNarrow?<div className="tileData" onMouseLeave={()=>{hoverNarrow()}} onMouseEnter={()=>{hoverWidth()}}>
        {content}
    </div>:
    <div className="tileDataWidth" onMouseLeave={()=>{hoverNarrow()}} onMouseEnter={()=>{hoverWidth()}}>
    <p>{days[props.children.split(" ")[0]] + " " +props.children.split(" ")[1]}</p>
    </div>}
    </>;
    }

export default DataTile;
